// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme variables */

:root {
  /* Theme customization variables */
  --primary-color: #1a2f4d; /* orthodox-blue-800 */
  --secondary-color: #f2ca54; /* orthodox-gold-500 */
  --bg-color: #ffffff;
  --text-color: #111827;
  --heading-color: #1a2f4d;
  --font-primary: var(--font-inter), system-ui, -apple-system, sans-serif;
  --font-secondary: var(--font-playfair), Georgia, serif;
  --border-radius: 0.375rem;
  --container-max-width: 80rem;
  --navbar-height: 4rem;
  
  /* Original variables */
  --foreground-rgb: 0, 0, 0;
  --background-start-rgb: 248, 250, 252;
  --background-end-rgb: 255, 255, 255;
}

/* Theme utility classes */
.bg-theme-primary {
  background-color: var(--primary-color);
}

.text-theme-primary {
  color: var(--primary-color);
}

.bg-theme-secondary {
  background-color: var(--secondary-color);
}

.text-theme-secondary {
  color: var(--secondary-color);
}

.text-theme {
  color: var(--text-color);
}

.bg-theme {
  background-color: var(--bg-color);
}

.rounded-theme {
  border-radius: var(--border-radius);
}

/* Body base styling using theme variables */
body {
  color: rgb(var(--foreground-rgb));
  background: linear-gradient(
      to bottom,
      transparent,
      rgb(var(--background-end-rgb))
    )
    rgb(var(--background-start-rgb));
}

/* Custom font styling */
.font-serif {
  font-family: var(--font-secondary);
}

.font-sans {
  font-family: var(--font-primary);
}`, "",{"version":3,"sources":["webpack://./src/styles/themes/index.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,kCAAkC;EAClC,wBAAwB,EAAE,sBAAsB;EAChD,0BAA0B,EAAE,sBAAsB;EAClD,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,uEAAuE;EACvE,sDAAsD;EACtD,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;;EAErB,uBAAuB;EACvB,yBAAyB;EACzB,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,4CAA4C;AAC5C;EACE,iCAAiC;EACjC;;;;;oCAKkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* Theme variables */\n\n:root {\n  /* Theme customization variables */\n  --primary-color: #1a2f4d; /* orthodox-blue-800 */\n  --secondary-color: #f2ca54; /* orthodox-gold-500 */\n  --bg-color: #ffffff;\n  --text-color: #111827;\n  --heading-color: #1a2f4d;\n  --font-primary: var(--font-inter), system-ui, -apple-system, sans-serif;\n  --font-secondary: var(--font-playfair), Georgia, serif;\n  --border-radius: 0.375rem;\n  --container-max-width: 80rem;\n  --navbar-height: 4rem;\n  \n  /* Original variables */\n  --foreground-rgb: 0, 0, 0;\n  --background-start-rgb: 248, 250, 252;\n  --background-end-rgb: 255, 255, 255;\n}\n\n/* Theme utility classes */\n.bg-theme-primary {\n  background-color: var(--primary-color);\n}\n\n.text-theme-primary {\n  color: var(--primary-color);\n}\n\n.bg-theme-secondary {\n  background-color: var(--secondary-color);\n}\n\n.text-theme-secondary {\n  color: var(--secondary-color);\n}\n\n.text-theme {\n  color: var(--text-color);\n}\n\n.bg-theme {\n  background-color: var(--bg-color);\n}\n\n.rounded-theme {\n  border-radius: var(--border-radius);\n}\n\n/* Body base styling using theme variables */\nbody {\n  color: rgb(var(--foreground-rgb));\n  background: linear-gradient(\n      to bottom,\n      transparent,\n      rgb(var(--background-end-rgb))\n    )\n    rgb(var(--background-start-rgb));\n}\n\n/* Custom font styling */\n.font-serif {\n  font-family: var(--font-secondary);\n}\n\n.font-sans {\n  font-family: var(--font-primary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
